export type PublicId<T extends string> = `${T}_${string}`;

export type AccountId = PublicId<"accnt">;
export type LocationId = PublicId<"loca">;
export type PatientId = PublicId<"patnt">;
export type UserId = PublicId<"user">;
export type LocationUserId = PublicId<"locusr">;
export type ConversationId = PublicId<"cnvrs">;
export type InsurancePlanId = PublicId<"inspln">;

// Insurance plans
// TODO: maybe move this to its own file
export type RenewalMonth = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;
export type InsurancePlan = {
  id: InsurancePlanId;
  name: string;
  renewalMonth: RenewalMonth;
};

export function getBaseOdontogramUrl(patientId: PatientId, locationId: LocationId): string {
  return `/locations/${locationId}/patients/${patientId}/odontogram`;
}

export { fetchJSON, FetchError, fetchErrorMessage } from "~/request";
